import api from "@/api/api";
import { montarUrl } from "@/helpers/apuracaoCapex";

/**
 * Cliente HTTP da Apuração CAPEX (`v1/apuracaocapex`) — só transporte. A montagem da
 * query, a ordenação e a normalização de `data`/`meta` ficam em `@/helpers/apuracaoCapex`.
 * Erros (`422`/`403`/`404`) são exibidos pelo `notify(erro)` do mixin global.
 */

/**
 * GET na API do módulo.
 *
 * ⚠️ Sem cancelamento: o axios do projeto é 0.21 (`signal` só a partir do 0.22).
 *
 * @param {number|string} empresaId
 * @param {string} caminho ex.: `enquadramentos`, `classificacoes/timesheets`, `apuracao/projetos`
 * @param {object} [params] `ano_base`, `page`, `per_page`, `filters`, `sort`…
 * @returns {Promise<any>} o corpo da resposta (`data`/`meta`/`totais`)
 */
export const get = (empresaId, caminho, params) =>
  api.get(montarUrl(empresaId, caminho, params)).then(({ data }) => data);

/**
 * POST na API do módulo (gravação em lote: enquadramento, classificação de fase).
 * @returns {Promise<any>}
 */
export const post = (empresaId, caminho, corpo, params) =>
  api.post(montarUrl(empresaId, caminho, params), corpo).then(({ data }) => data);

/**
 * DELETE na API do módulo — a API espera o corpo (`lancamentos`) também na exclusão.
 * @returns {Promise<any>}
 */
export const remover = (empresaId, caminho, corpo, params) =>
  api.delete(montarUrl(empresaId, caminho, params), { data: corpo }).then(({ data }) => data);

export default { get, post, remover };

export { montarQuery, montarUrl, normalizarPagina } from "@/helpers/apuracaoCapex";
